module.exports = __webpack_public_path__ + "img/notification_respond.5b5c5886.svg";